interface UrlMap {
  [key: string]: string | undefined;
}
export function getUrlVars() {
  const urlParams: UrlMap = {},
    a = /\+/g, // Regex for replacing addition symbol with a space
    r = /([^&=]+)=?([^&]*)/g,
    d = function (s: string) {
      return decodeURIComponent(s.replace(a, " "));
    },
    q = window.location.search.substring(1);

  let e;

  while ((e = r.exec(q))) {
    urlParams[d(e[1]).toLowerCase()] = d(e[2]);
  }

  return urlParams;
}

export function getQueryString(propKey: string) {
  const params = new URLSearchParams(window.location.search.toLowerCase());
  return params.get(propKey.toLowerCase());
}
